import { render, staticRenderFns } from "./_DeferredReviewItem.vue?vue&type=template&id=3e6da032&scoped=true&"
import script from "./_DeferredReviewItem.vue?vue&type=script&lang=js&"
export * from "./_DeferredReviewItem.vue?vue&type=script&lang=js&"
import style0 from "./_DeferredReviewItem.vue?vue&type=style&index=0&id=3e6da032&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6da032",
  null
  
)

export default component.exports